module.exports = __webpack_public_path__ + "img/VV.ba91f6ee.png";